import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, ButtonGroup, Segment } from 'semantic-ui-react';
import ClientCredentials from './ClientCredentials';
import ClientModules from './ClientModules';
import ClientTasks from './ClientTasks';
import ClientUsers from './ClientUsers';
import ClientModelParameters from './ClientModelParameters';
import ClientProperties from './ClientProperties';
import SystemSettings from './SystemSettings';
import JobLogs from '../Jobs/JobLogs';
import PropertySettings from './PropertySettings';

const subModules = [
  'Tasks',
  'UI Modules',
  'Credentials',
  'Users',
  'Model Parameter',
  'Managed Properties',
  'System Settings',
  'Property Settings',
  'Task Logs',
];

const ClientData = (props: any) => {
  const [active, setActive] = useState(subModules[0].toLowerCase());
  const { users, tasks, credentials, uiModules, client } = props.data;
  const id = props.id;
  const dispatch = useDispatch();
  const setActiveTab = (e) => {
    setActive(e.target.textContent.toLowerCase());
  };
  return (
    <Segment>
      <ButtonGroup>
        {subModules.map((el: string, index: number) => {
          return (
            <Button
              key={`${el.toLowerCase().replaceAll(' ', '_')}_${index}`}
              onClick={setActiveTab}
              active={active === el.toLowerCase()}
            >
              {el}
            </Button>
          );
        })}
      </ButtonGroup>
      <div>
        {active === subModules[0].toLowerCase() ? (
          <ClientTasks tasks={tasks} clientId={id} dispatch={dispatch} />
        ) : null}
        {active === subModules[1].toLowerCase() ? (
          <ClientModules
            modules={uiModules}
            clientId={id}
            dispatch={dispatch}
            client={client}
          />
        ) : null}
        {active === subModules[2].toLowerCase() ? (
          <ClientCredentials
            credentials={credentials}
            clientId={id}
            dispatch={dispatch}
          />
        ) : null}
        {active === subModules[3].toLowerCase() ? (
          <ClientUsers users={users} clientId={id} dispatch={dispatch} />
        ) : null}
        {active === subModules[4].toLowerCase() ? (
          <ClientModelParameters clientId={id} />
        ) : null}
        {active === subModules[5].toLowerCase() ? (
          <ClientProperties clientId={id} client={client} />
        ) : null}
        {active === subModules[6].toLowerCase() ? (
          <SystemSettings clientId={id} />
        ) : null}
        {active === subModules[7].toLowerCase() ? (
          <PropertySettings clientId={id} client={client} />
        ) : null}
        {active === subModules[8].toLowerCase() ? (
          <JobLogs clientId={id} />
        ) : null}
      </div>
    </Segment>
  );
};

export default ClientData;
